"use client"

import { useRef, useEffect } from "react"
import "./Blog.css"
import metalcontainers from "../assets/blogs/metal-containers.jpg"
import easyopens from "../assets/products/easy-open-1.jpg"

const Blog = () => {
  const sectionRef = useRef(null)

  const blogPosts = [
    {
      id: 1,
      title: "The Evolution of Metal Containers: Why We Call Them “Cans”",
      excerpt:
        "Explore how metal containers has evolved over the decades to meet changing consumer needs and industry standards.",
      image: metalcontainers,
      date: "August 09, 2024",
      author: "Aarti",
      category: "Industry Trends",
      link: "https://www.linkedin.com/posts/abmmetaltech_abmmetaltech-metaltincontainers-tincanmanufacturers-activity-7227622171257278465-yFd3?utm_source=share&utm_medium=member_desktop&rcm=ACoAAE6de5cBN1U5YX6QBaCe2xAaYB8buW112lw"
    },
    {
      id: 2,
      title: "The Future of Food Packaging is Here – Say Goodbye to Frustrating Lids!",
      excerpt: "Innovative designs are transforming food packaging to be easier, safer, and smarter than ever before.",
      image: easyopens,
      date: "Feb 08, 2025",
      author: "Aarti",
      category: "Sustainability",
      link: "https://www.linkedin.com/posts/abmmetaltech_innovationinpackaging-easyopenlids-foodpackagingrevolution-activity-7293885271790567424-GoDQ?utm_source=share&utm_medium=member_desktop&rcm=ACoAAE6de5cBN1U5YX6QBaCe2xAaYB8buW112lw",
    },
    {
      id: 3,
      title: "Exclusively Food-Grade Tin Can Solutions for Edible Foods",
      excerpt: "Discover reliable, food-safe tin can packaging designed specifically to preserve the quality and safety of edible products.",
      image: "/placeholder.svg?height=300&width=500",
      date: "November 28, 2024",
      author: "Aarti",
      category: "Innovation",
      link: "https://www.linkedin.com/posts/abmmetaltech_foodgradepackaging-tincanmanufacturing-sustainablepackaging-activity-7267881578381332480-YWJK?utm_source=share&utm_medium=member_desktop&rcm=ACoAAE6de5cBN1U5YX6QBaCe2xAaYB8buW112lw",
    },
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
          }
        })
      },
      { threshold: 0.1 },
    )

    const animatedElements = sectionRef.current.querySelectorAll(".animate-in")
    animatedElements.forEach((el) => observer.observe(el))

    return () => {
      animatedElements.forEach((el) => observer.unobserve(el))
    }
  }, [])

  return (
    <div className="blog section-bg" ref={sectionRef}>
      <div className="container">
        <h2 className="text-center animate-in">Blog & Updates</h2>
        <p className="blog-subtitle text-center animate-in">
          Stay informed with the latest industry news, trends, and insights
        </p>

        <div className="blog-grid">
          {blogPosts.map((post, index) => (
            <div className="blog-card animate-in" key={post.id} style={{ animationDelay: `${index * 0.1}s` }}>
              <div className="blog-image">
                <img src={post.image || "/placeholder.svg"} alt={post.title} />
                <div className="blog-category">{post.category}</div>
              </div>
              <div className="blog-content">
                <div className="blog-meta">
                  <span className="blog-date">{post.date}</span>
                  <span className="blog-author">by {post.author}</span>
                </div>
                <h3>{post.title}</h3>
                <p>{post.excerpt}</p>
                <a href={post.link} target="_blank" rel="noopener noreferrer" className="blog-read-more">
                  Read More
                </a>
              </div>
            </div>
          ))}
        </div>

        <div className="blog-cta text-center animate-in">
          <a href="#blog" className="btn btn-outline">
            View All Posts
          </a>
        </div>
      </div>
    </div>
  )
}

export default Blog
